// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm_dialog__message {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 1.5;
    color: var(--color-text);
}

.confirm_dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.confirm_dialog__btn {
    padding: 7px 15px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    transition: background-color 0.1s, opacity 0.1s;
}

.confirm_dialog__btn--cancel {
    background-color: var(--color-bg-3);
    color: var(--color-text-muted);
}

@media (pointer: fine) {
    .confirm_dialog__btn--cancel:hover {
        background-color: var(--color-border);
        color: var(--color-text);
    }
}

.confirm_dialog__btn--confirm {
    background-color: var(--color-accent);
    color: #ffffff;
}

@media (pointer: fine) {
    .confirm_dialog__btn--confirm:hover {
        background-color: var(--color-accent-hover);
    }
}

.confirm_dialog__btn--danger {
    background-color: var(--color-danger, #e53e3e);
    color: #ffffff;
}

@media (pointer: fine) {
    .confirm_dialog__btn--danger:hover {
        background-color: var(--color-danger-hover, #c53030);
    }
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/ConfirmDialog/s.confirm_dialog.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI;QACI,qCAAqC;QACrC,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI;QACI,oDAAoD;IACxD;AACJ","sourcesContent":[".confirm_dialog__message {\n    margin: 0 0 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--color-text);\n}\n\n.confirm_dialog__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.confirm_dialog__btn {\n    padding: 7px 15px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.1s, opacity 0.1s;\n}\n\n.confirm_dialog__btn--cancel {\n    background-color: var(--color-bg-3);\n    color: var(--color-text-muted);\n}\n\n@media (pointer: fine) {\n    .confirm_dialog__btn--cancel:hover {\n        background-color: var(--color-border);\n        color: var(--color-text);\n    }\n}\n\n.confirm_dialog__btn--confirm {\n    background-color: var(--color-accent);\n    color: #ffffff;\n}\n\n@media (pointer: fine) {\n    .confirm_dialog__btn--confirm:hover {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.confirm_dialog__btn--danger {\n    background-color: var(--color-danger, #e53e3e);\n    color: #ffffff;\n}\n\n@media (pointer: fine) {\n    .confirm_dialog__btn--danger:hover {\n        background-color: var(--color-danger-hover, #c53030);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
